module.exports = __webpack_public_path__ + "static/media/autogram.a2c54288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/autogram.jpg
// module id = 72
// module chunks = 0